// Componente per visualizzare i riferimenti normativi
const Riferimenti = ({ data }) => {
  if (data?.riferimentiNormativi.length) {
    return (
      <ul style={{ overflow: "hidden" }}>
        {data.riferimentiNormativi.map((el) => {
          return (
            <li key={el.idRiferimento}>
              <a href={el.link} target="_blank" rel="noopener noreferrer">
                {el.descrizione}
              </a>
            </li>
          );
        })}
      </ul>
    );
  } else return data?.riferimentiNormativiFallback;
};

export default Riferimenti;
